export const environment = {
  production: false,
  baseUrl: 'https://cms.slji.purple.lk',
  // baseUrl: 'http://localhost:5002',
  // baseUrl: 'https://cms.judgesinstitute.lk',
};
